import React, { useContext } from "react";

const RefreshContext = React.createContext(() => {});

const useRefresh = () => useContext(RefreshContext);

const RefreshProvider = ({ refresh, children }) => (
    <RefreshContext.Provider value={refresh}>
        {children}
    </RefreshContext.Provider>
);

export { RefreshProvider, useRefresh };
